const redAreaText = {
    p1:" These neighborhoods are the most affected by boars according to municipality of Haifa.",
    p2:" If you have more questions about the boars or about the services that you can receive from the municipality of haifa you can visit their.",
    link : "https://www.haifa.muni.il/operation/boars/"
  };
  export default redAreaText;
  